module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 19
// module chunks = 17